import { hideElement, isIframe, setReadOpacityForElementsById, showElement } from './helper.js';
import { heftDetailAusgabenCount, newsletterDetailAusgabenCount } from './ArtikelVerbleibend.js';

import contentTracker from "./InhaltGelesen";

document.addEventListener('DOMContentLoaded', addArticleReadClickEvents);
document.addEventListener('htmx:afterSettle', addArticleReadClickEvents);

document.addEventListener('DOMContentLoaded', markArticlesAsRead);
document.addEventListener('htmx:afterSettle', markArticlesAsRead);

document.addEventListener('DOMContentLoaded', readCurrentArticle);
document.addEventListener('htmx:afterSettle', readCurrentArticle);

// Page navigation vor/zurück knopf Artikel markieren
window.addEventListener('pageshow', (event) => {
    if (event.eventPhase == 2 && String(window.performance.getEntriesByType("navigation")[0].type) == "back_forward") {
        markArticlesAsRead();
    }
});

//
// Hier werden die Artikel gelesen/ungelesen.
// Alle Funktionnen und CLick events die das Lesen von Artikeln betreffen sind hier zu finden
// z.B. Artikel Teaser gelesen markieren Knopf oder Artikel lesen funktion
//

function readCurrentArticle() {
    // Immer wenn Artikeldetail aufgerufen wird markiere Artikel als gelesen
    const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`);
    if (artikeldetail && !isIframe()) {
        const parts = artikeldetail.id.split('_');
        const artikel_id = parts[parts.length - 1];
        let content_paywall = document.getElementById("paywall_login");
        // Wenn keine Paywall zu finden zählt der Artikel als gelesen
        if (content_paywall == null) {
            contentTracker.getContent(artikel_id).then(artikelStatusInfo => {
                if (!artikelStatusInfo.gelesenStatus) {
                    contentTracker.setContentStatus(artikel_id, "artikel", true);
                }
            });
        }
    }
}

/**
 * @description Füge alle gelesen/ungelesen Knöpfen eine click event hinzu zum markieren und updaten des storages
 */
function addArticleReadClickEvents() {
    const links = document.querySelectorAll(`[id^="button_artikel_teaser_read_"]`);
    links.forEach(function (link) {
        link.addEventListener('click', function () {
            const parts = link.id.split('_');
            const artikel_id = parts[parts.length - 1];
            markArticleTeasersAsRead([artikel_id]);
            contentTracker.setContentStatus(artikel_id, "artikel", true).then(() => {
                contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
                    heftDetailAusgabenCount(articles_read);
                    newsletterDetailAusgabenCount(articles_read);
                });
            });
        });
    });

    const links_unread = document.querySelectorAll(`[id^="button_artikel_teaser_not_read_"]`);
    links_unread.forEach(function (link) {
        link.addEventListener('click', function () {
            const parts = link.id.split('_');
            const artikel_id = parts[parts.length - 1];
            markArticleTeaserAsUnread(artikel_id);
            contentTracker.setContentStatus(artikel_id, "artikel", false).then(() => {
                contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
                    heftDetailAusgabenCount(articles_read);
                    newsletterDetailAusgabenCount(articles_read);
                });
            });
        });
    });
}

/**
 * @description Hole alle gelesene Artikel und markiere dessen Teaser und Progressbar Elemente
 */
function markArticlesAsRead() {
    contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
        if (articles_read == null) { return; }
        markArticleTeasersAsRead(articles_read);
        markArticleProgressbarAsRead(articles_read);
    });
}

/**
 * @description Finde alle Progressbar elemente die gelesen sind und ersetze diese
 * @param articles_read
 */
function markArticleProgressbarAsRead(articles_read) {
    let markers = document.querySelectorAll("[id^=start_marker_]");

    markers.forEach(mark => {
        let id = mark.getAttribute("id").replace("start_marker_", "");
        if (articles_read.includes(id)) {
            hideElement(["start_marker_" + id]);
            showElement(["checked_start_marker_" + id]);
        } else {
            showElement(["start_marker_" + id]);
            hideElement(["checked_start_marker_" + id]);
        }
    });
}

/**
 * @description Entferne opacity von einem einzelenen Artikel und ersetzte Knöpfe
 * @param artikel_id
 */
function markArticleTeaserAsUnread(artikel_id) {
    setReadOpacityForElementsById(["artikel_teaser_" + artikel_id], false);
    hideElement(["button_artikel_teaser_not_read_" + artikel_id]);
    showElement(["button_artikel_teaser_read_" + artikel_id]);
}

/**
 * @description Füge alle gelesenen Artikeln opacity hinzu und ersetze Knöpfe
 * @param article_ids
 */
function markArticleTeasersAsRead(article_ids) {
    setReadOpacityForElementsById(article_ids.map((element) => "artikel_teaser_" + element), true);
    showElement(article_ids.map((element) => "button_artikel_teaser_not_read_" + element));
    hideElement(article_ids.map((element) => "button_artikel_teaser_read_" + element));
}
